export const SEND_RATE_LIMITS = Object.freeze({
    ordinaryUserPerHour: 60,
    spawnedLineageSessionPerHour: 30,
});
/**
 * The server derives this classification from its session binding and ACLs;
 * clients never choose their own rate-limit class.
 */
export function classifyRateLimit(context) {
    const boundedLineage = context.executionMode === "spawned_headless"
        && context.recipientsAllOwnedByUser
        && context.authorizedPlanLineage;
    if (boundedLineage && context.mutation === "complete") {
        return lineageDecision("lineage_completion", context);
    }
    if (boundedLineage && context.mutation === "send" && context.messageType === "wip") {
        return lineageDecision("lineage_progress", context);
    }
    return {
        class: "ordinary",
        bucketKey: `user:${context.userId}:ordinary-send`,
        limitPerHour: SEND_RATE_LIMITS.ordinaryUserPerHour,
        countsTowardOrdinaryUserLimit: true,
    };
}
function lineageDecision(rateClass, context) {
    return {
        class: rateClass,
        bucketKey: `session:${context.sessionId}:lineage:${context.lineageRootSessionId}`,
        limitPerHour: SEND_RATE_LIMITS.spawnedLineageSessionPerHour,
        countsTowardOrdinaryUserLimit: false,
    };
}
//# sourceMappingURL=rate-limit.js.map